import React from "react";
import { useNavigate } from "react-router-dom";

const AboutBanner = () => {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate("/contact-us", { state: { scrollToForm: true } }); // Pass state
  };
  return (
    <div id="about-us-banner-container">
      <div id="about-us-banner">
        <div>
          <h1 className="about-title">
            Ready To Take Your Startup To The Next Level?
          </h1>
          <p className="contact-desc-message">
            Begin your journey today
          </p>
          <div>
            <button className="btn" onClick={handleGetStarted}>Get Started</button>
          </div>
        </div>
        <div>
          <img src="/about-us.svg" alt="conact-banner" className="about-img" />
        </div>
      </div>
    </div>
  );
};

export default AboutBanner;
